// extracted by mini-css-extract-plugin
export default {"animal-card-table":"styles_animal-card-table__SeBbn"};